import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import UserSidebar from "../components/user/UserSidebar";
import UserHeader from "../components/user/UserHeader";

import {
    userMe,
    getFreeMCQ
} from "../config/userApi";


function FreeMCQ() {

    const navigate = useNavigate();

    const [sidebarOpen, setSidebarOpen] = useState(false);

    const [name, setName] = useState("Student");

    const [papers, setPapers] = useState([]);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");


    /*
    |--------------------------------------------------------------------------
    | Get User + Free MCQ
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const loadFreeMCQ = async () => {

            try {

                setLoading(true);

                setError("");


                /*
                |--------------------------------------------------------------------------
                | Check Logged In User
                |--------------------------------------------------------------------------
                */

                const meResponse = await userMe();

                console.log(
                    "USER ME STATUS:",
                    meResponse.status
                );


                if (meResponse.status === 401) {

                    Cookies.remove("username");

                    navigate("/login", {
                        replace: true
                    });

                    return;
                }


                /*
                |--------------------------------------------------------------------------
                | Read User Response
                |--------------------------------------------------------------------------
                */

                const meResult =
                    await meResponse.json();

                console.log(
                    "USER ME RESPONSE:",
                    meResult
                );


                if (!meResponse.ok) {

                    throw new Error(
                        meResult.message ||
                        "Unable to verify user login."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Set Username
                |--------------------------------------------------------------------------
                */

                if (meResult.user) {

                    const username =
                        meResult.user.fullname ||
                        meResult.user.name ||
                        meResult.user.username ||
                        "Student";

                    setName(username);
                }


                /*
                |--------------------------------------------------------------------------
                | Get Free MCQ
                |--------------------------------------------------------------------------
                */

                const response =
                    await getFreeMCQ();

                console.log(
                    "FREE MCQ STATUS:",
                    response.status
                );


                /*
                |--------------------------------------------------------------------------
                | Unauthorized
                |--------------------------------------------------------------------------
                */

                if (response.status === 401) {

                    Cookies.remove("username");

                    navigate("/login", {
                        replace: true
                    });

                    return;
                }


                /*
                |--------------------------------------------------------------------------
                | Read MCQ Response
                |--------------------------------------------------------------------------
                */

                const result =
                    await response.json();

                console.log(
                    "FREE MCQ RESPONSE:",
                    result
                );


                if (!response.ok) {

                    throw new Error(
                        result.message ||
                        "Unable to fetch free MCQ papers."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Set Papers
                |--------------------------------------------------------------------------
                */

                setPapers(
                    Array.isArray(result.data)
                        ? result.data
                        : []
                );


            } catch (err) {

                console.error(
                    "FREE MCQ ERROR:",
                    err
                );

                setError(
                    err.message ||
                    "Unable to connect with server."
                );

            } finally {

                setLoading(false);

            }

        };


        loadFreeMCQ();

    }, [navigate]);


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    if (loading) {

        return (

            <div className="user-dashboard">

                <UserSidebar
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                />


                <main className="dashboard-main">

                    <UserHeader
                        name={name}
                        setSidebarOpen={setSidebarOpen}
                    />


                    <div
                        className="d-flex flex-column justify-content-center align-items-center"
                        style={{
                            minHeight: "70vh"
                        }}
                    >

                        <div
                            className="spinner-border text-primary mb-3"
                            style={{
                                width: "3rem",
                                height: "3rem"
                            }}
                            role="status"
                        >

                            <span className="visually-hidden">
                                Loading...
                            </span>

                        </div>


                        <h5 className="text-secondary">
                            Loading Free MCQs...
                        </h5>


                        <p className="text-muted mb-0">
                            Please wait a moment.
                        </p>

                    </div>

                </main>

            </div>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | Main UI
    |--------------------------------------------------------------------------
    */

    return (

        <div className="user-dashboard">


            {/* SIDEBAR */}

            <UserSidebar
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />


            {/* MAIN */}

            <main className="dashboard-main">


                {/* HEADER */}

                <UserHeader
                    name={name}
                    setSidebarOpen={setSidebarOpen}
                />


                {/* CONTENT */}

                <div className="dashboard-content py-4 px-3 px-md-4">


                    {/* =====================================================
                        PAGE HEADER
                    ===================================================== */}

                    <section
                        className="rounded-4 p-4 p-md-5 mb-4 shadow-sm"
                        style={{
                            background:
                                "linear-gradient(135deg, #eef6ff 0%, #ffffff 100%)",
                            border:
                                "1px solid #e2ecf7"
                        }}
                    >

                        <div className="row align-items-center">

                            <div className="col-lg-9">

                                <span
                                    className="badge rounded-pill px-3 py-2 mb-3"
                                    style={{
                                        backgroundColor: "#e8f1ff",
                                        color: "#0d6efd",
                                        fontSize: "12px",
                                        letterSpacing: "0.5px"
                                    }}
                                >

                                    <i className="bi bi-journal-check me-2"></i>

                                    FREE PRACTICE

                                </span>


                                <h1
                                    className="fw-bold mb-2"
                                    style={{
                                        color: "#172b4d"
                                    }}
                                >
                                    Free MCQ Practice
                                </h1>


                                <p
                                    className="text-secondary mb-0"
                                    style={{
                                        maxWidth: "650px",
                                        lineHeight: "1.7"
                                    }}
                                >
                                    Practice important medical questions
                                    and strengthen your preparation with
                                    our free MCQ papers.
                                </p>

                            </div>


                            <div className="col-lg-3 d-none d-lg-flex justify-content-end">

                                <div
                                    className="d-flex align-items-center justify-content-center rounded-circle"
                                    style={{
                                        width: "110px",
                                        height: "110px",
                                        backgroundColor: "#e8f1ff",
                                        color: "#0d6efd",
                                        fontSize: "48px"
                                    }}
                                >

                                    <i className="bi bi-journal-medical"></i>

                                </div>

                            </div>

                        </div>

                    </section>


                    {/* =====================================================
                        ERROR
                    ===================================================== */}

                    {error && (

                        <div
                            className="alert alert-danger d-flex align-items-start rounded-3 shadow-sm"
                            role="alert"
                        >

                            <i className="bi bi-exclamation-triangle-fill fs-5 me-3"></i>

                            <div>

                                <strong>
                                    Unable to load Free MCQs
                                </strong>

                                <div className="small mt-1">
                                    {error}
                                </div>

                            </div>

                        </div>

                    )}


                    {/* =====================================================
                        EMPTY
                    ===================================================== */}

                    {!error && papers.length === 0 && (

                        <div
                            className="bg-white rounded-4 shadow-sm text-center p-5"
                            style={{
                                border: "1px solid #e9ecef"
                            }}
                        >

                            <div
                                className="mx-auto mb-4 d-flex align-items-center justify-content-center rounded-circle"
                                style={{
                                    width: "90px",
                                    height: "90px",
                                    backgroundColor: "#f1f5f9",
                                    color: "#64748b",
                                    fontSize: "40px"
                                }}
                            >

                                <i className="bi bi-journal-x"></i>

                            </div>


                            <h3 className="fw-bold text-dark">
                                No Free MCQs Available
                            </h3>


                            <p
                                className="text-muted mb-0"
                                style={{
                                    maxWidth: "500px",
                                    margin: "0 auto"
                                }}
                            >
                                There are currently no free MCQ papers
                                available for practice. Please check again
                                later.
                            </p>

                        </div>

                    )}


                    {/* =====================================================
                        PAPERS
                    ===================================================== */}

                    {papers.length > 0 && (

                        <section>


                            {/* SECTION HEADER */}

                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">

                                <div>

                                    <h2
                                        className="fw-bold mb-1"
                                        style={{
                                            color: "#172b4d"
                                        }}
                                    >
                                        Available Papers
                                    </h2>


                                    <p className="text-muted mb-0">
                                        Choose a paper and start your practice.
                                    </p>

                                </div>


                                <div
                                    className="badge rounded-pill mt-3 mt-md-0 px-3 py-2"
                                    style={{
                                        backgroundColor: "#f0f7ff",
                                        color: "#0d6efd",
                                        fontSize: "14px"
                                    }}
                                >

                                    <i className="bi bi-files me-2"></i>

                                    {papers.length} Papers

                                </div>

                            </div>


                            {/* PAPER GRID */}

                            <div className="row g-4">

                                {papers.map((paper, index) => (

                                    <div
                                        className="col-12 col-md-6 col-xl-4"
                                        key={paper.paper_id}
                                    >

                                        <div
                                            className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden"
                                            style={{
                                                transition:
                                                    "all 0.25s ease"
                                            }}
                                        >

                                            <div className="card-body p-4">


                                                {/* CARD TOP */}

                                                <div className="d-flex justify-content-between align-items-center mb-4">

                                                    <div
                                                        className="d-flex align-items-center justify-content-center rounded-3 fw-bold"
                                                        style={{
                                                            width: "45px",
                                                            height: "45px",
                                                            backgroundColor: "#f1f6ff",
                                                            color: "#0d6efd"
                                                        }}
                                                    >

                                                        {String(
                                                            index + 1
                                                        ).padStart(2, "0")}

                                                    </div>


                                                    <span
                                                        className="badge rounded-pill px-3 py-2"
                                                        style={{
                                                            backgroundColor: "#eaf8ef",
                                                            color: "#198754"
                                                        }}
                                                    >

                                                        <i className="bi bi-check-circle-fill me-1"></i>

                                                        FREE

                                                    </span>

                                                </div>


                                                {/* ICON */}

                                                <div
                                                    className="d-flex align-items-center justify-content-center rounded-4 mb-4"
                                                    style={{
                                                        width: "65px",
                                                        height: "65px",
                                                        backgroundColor: "#0d6efd",
                                                        color: "#fff",
                                                        fontSize: "28px"
                                                    }}
                                                >

                                                    <i className="bi bi-journal-text"></i>

                                                </div>


                                                {/* TITLE */}

                                                <h4
                                                    className="fw-bold mb-2"
                                                    style={{
                                                        color: "#172b4d",
                                                        lineHeight: "1.4"
                                                    }}
                                                >

                                                    {paper.paper}

                                                </h4>


                                                {/* CATEGORY */}

                                                <div
                                                    className="d-flex align-items-center mb-4"
                                                    style={{
                                                        color: "#6c757d",
                                                        fontSize: "14px"
                                                    }}
                                                >

                                                    <i className="bi bi-bookmark-fill me-2"></i>

                                                    {paper.category ||
                                                        "Sample Paper"}

                                                </div>


                                                {/* DETAILS */}

                                                <div
                                                    className="rounded-3 p-3 mb-4"
                                                    style={{
                                                        backgroundColor: "#f8f9fa"
                                                    }}
                                                >

                                                    <div className="row">

                                                        <div className="col-6">

                                                            <div className="d-flex align-items-center">

                                                                <i
                                                                    className="bi bi-question-circle-fill me-2"
                                                                    style={{
                                                                        color: "#0d6efd"
                                                                    }}
                                                                ></i>

                                                                <div>

                                                                    <small className="text-muted d-block">
                                                                        Questions
                                                                    </small>

                                                                    <strong className="text-dark">
                                                                        {paper.total_questions || 0}
                                                                    </strong>

                                                                </div>

                                                            </div>

                                                        </div>


                                                        <div className="col-6">

                                                            <div className="d-flex align-items-center">

                                                                <i
                                                                    className="bi bi-clock-fill me-2"
                                                                    style={{
                                                                        color: "#0d6efd"
                                                                    }}
                                                                ></i>

                                                                <div>

                                                                    <small className="text-muted d-block">
                                                                        Mode
                                                                    </small>

                                                                    <strong className="text-dark">
                                                                        Practice
                                                                    </strong>

                                                                </div>

                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>


                                                {/* =====================================================
                                                    ATTEMPT BUTTON
                                                ===================================================== */}

                                                {paper.attempt_count === 0 && (

                                                    <Link
                                                        to={`/free-mcq/exam/${paper.paper_id}`}
                                                        className="btn btn-primary w-100 rounded-3 py-2 fw-semibold"
                                                    >

                                                        Start Practice

                                                        <i className="bi bi-arrow-right ms-2"></i>

                                                    </Link>

                                                )}


                                                {paper.attempt_count === 1 && (

                                                    <Link
                                                        to={`/free-mcq/exam/${paper.paper_id}`}
                                                        className="btn btn-warning w-100 rounded-3 py-2 fw-semibold"
                                                    >

                                                        <i className="bi bi-arrow-repeat me-2"></i>

                                                        Reattempt

                                                        <i className="bi bi-arrow-right ms-2"></i>

                                                    </Link>

                                                )}


                                                {paper.attempt_count >= 2 && (

                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary w-100 rounded-3 py-2 fw-semibold"
                                                        disabled
                                                    >

                                                        <i className="bi bi-check-circle me-2"></i>

                                                        You have attempted

                                                    </button>

                                                )}

                                            </div>

                                        </div>

                                    </div>

                                ))}

                            </div>

                        </section>

                    )}

                </div>

            </main>

        </div>

    );

}


export default FreeMCQ;
